import {useMutation} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {QueryCRUDTypes} from '../../../query-manager/QueryKeysManager'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {createOrUpdateAdditionalInfo} from '../AdditionalInformationEndPoint'

export const useAdditionalInformationCRUD = (type, requestorId) => {
    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateAdditionalInfo(requestorId, data)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Additional Information Update Successfully !!',
                    )
                }
            }
        },
    })
}
